import './index.css'

import React, { useCallback, useRef, useState } from 'react'
import Popover from 'components/ui/popover'
import useClickOutside from 'hooks/use-click-outside'
import type { PopoverItemType } from 'types/ui'
type Props = {
  iconNode: React.ReactNode
  items: PopoverItemType[]
  onItemClick: (...args: Array<any>) => any
  className?: string
} // TODO: use in src/app2/views/components/header/help-menu/index.js
// TODO: use in src/app2/views/components/header/menu/index.js

/**
 * A button component that toggles a popover menu with clickable items
 * @param iconNode - React node to display as the button icon
 * @param items - Array of popover menu items to display
 * @param onItemClick - Callback function called when a popover item is clicked
 * @returns Button with toggle functionality and conditional popover menu
 */
export default function PopoverButton(props: Props): React.ReactNode {
  const { iconNode, items, onItemClick } = props
  const [menuOpen, setMenuOpen] = useState(false)
  const toggle = useCallback(() => {
    setMenuOpen(m => !m)
  }, [])
  const close = useCallback(() => {
    setMenuOpen(false)
  }, [])
  const ref = useRef()
  useClickOutside(ref, close)
  return (
    <>
      <button ref={ref} onClick={toggle} className={props.className}>
        {iconNode}
      </button>
      {menuOpen && (
        <div className="PopoverButton">
          <Popover items={items} onClick={onItemClick} />
        </div>
      )}
    </>
  )
}
